import { MessagingClient } from '@agoda/messaging-client'
import sw from '@agoda/messaging-client/dist/messaging-client-worker.js'
import polyfill from '@agoda/messaging-client/dist/messaging-client-polyfills.js'

const qa = window.location.hostname.split('.')
export const messagingClient = MessagingClient.instantiate({
    apiKey: 'ycs',
    mode: qa.length < 2 || qa[1] === 'qa' ? 'development' : 'production',
    workerUrl: sw,
    polyfillsUrl: polyfill,
})